<template>
  <v-btn
    v-if="showButton"
    icon
    class="pwa-install-button app-bar-icon-button"
    aria-label="Install Self Biography"
    title="Install Self Biography"
    @click="openInstallDialog"
  >
    <v-icon>{{ mdiDownload }}</v-icon>
  </v-btn>
</template>

<script>
import { mdiDownload } from '@mdi/js'
import { pwaState, openInstallDialog } from '@/services/pwa'

export default {
  data: () => ({ pwa: pwaState, mdiDownload }),
  computed: {
    showButton() { return this.pwa.ready && this.pwa.secure && !this.pwa.installed },
  },
  methods: { openInstallDialog },
}
</script>
